import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NgIf, NgClass, NgStyle } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
@Component({
  selector: 'NiAlert',
  standalone: true,
  imports: [NgIf, NgClass, NgStyle],
  templateUrl: './ni-alert.component.html',
  styleUrl: './ni-alert.component.css',
  animations: [
    trigger('alertAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'scale(0.9)' }))
      ]),
    ])
  ]
})

export class NiAlertComponent {
  @Input() isVisible: boolean = true;
  @Input() message: string = "";
  @Input() icon: string = "";
  @Input() duration: number = 3000;
  @Input() variant: "success" | "danger" | "warning" | "info" = "success";
  @Input() position: "top-left" | "top-right" | "bottom-left" | "bottom-right" = "top-right";
  @Input() dismissible: boolean = false;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  private timeoutId: any;

  ngOnInit() {
    if (this.duration > 0) {
      this.timeoutId = setTimeout(() => this.close(), this.duration);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['variant']) {
      this.variant = changes['variant'].currentValue;
    }
  }

  close(): void {
    this.isVisible = false;
    clearTimeout(this.timeoutId);
    this.onClose.emit();
  }

  positions = {
    "top-left": "top-2 left-2",
    "top-right": "top-2 right-2",
    "bottom-left": "bottom-2 left-2",
    "bottom-right": "bottom-2 right-2"
  }

  variants = {
    "success": "ni-alert--success",
    "danger": "ni-alert--danger",
    "warning": "ni-alert--warning",
    "info": "ni-alert--info"
  }

  positionStyles: Record<"top-left" | "top-right" | "bottom-left" | "bottom-right", Record<string, string>> = {
    "top-left": { top: 'calc(var(--staff-layout-height, 0px) + 0.5rem)' },
    "top-right": { top: 'calc(var(--staff-layout-height, 0px) + 0.5rem)' },
    "bottom-left": {},
    "bottom-right": {}
  };
}